// extracted by mini-css-extract-plugin
export default {"containerInfoBox":"CampaignInfoBox_containerInfoBox__mMc4Y"};